import { mapState } from 'vuex';
import 'firebase/storage';
import { EventsTypes } from '@/enums/EventsTypes';
import moment from 'moment';
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import Loader from '@/components/loader/Loader.vue';
import { dateFormats } from '@/consts/DateTimeFormats';
import { CallsTypes } from '@/enums/CallsTypes';

export default {
  name: 'ViewRealtimeCall',
  components: {
    CoolLightBox,
    Loader,
  },
  data: () => ({
    flexHeight: 500,
    readonly: true,
    eventsTypes: EventsTypes,
    loading: true,
  }),

  computed: {
    ...mapState({
      currentCall() {
        return this.$store.state.callsModule.currentCall;
      },
      currentFacility() {
        return this.$store.state.authModule.currentFacility;
      },
      facility() {
        return this.$store.state.facilityModule.selectedFacility;
      },
      CallsTypes() {
        return CallsTypes;
      },
      callCreator() {
        return this.currentCall.participants.find(
          participant => participant.isHost === true
        );
      },
      callParticipants() {
        return this.currentCall.participants;
      },
    }),
    formattedStartDateTime() {
      return moment(this.currentCall.start).format(
        this.facility.dateFormat + ' ' + this.facility.timeFormat
      );
    },
    eventTypes() {
      return [...Object.values(EventsTypes)];
    },
    eventTypesEnum() {
      return EventsTypes;
    }
  },
  async mounted() {
    try {
      this.loading = true;
      const id = this.$route.params.id;

      await this.$store.dispatch('getFacility');
      await this.$store.dispatch('getCallById', id);

      const dateFormat = dateFormats.find(x => x.format == this.facility.dateFormat);
      this.hintDateHormat = dateFormat ? dateFormat.name : dateFormats[0].name;
      this.hintTimeHormat = this.facility.timeFormat.includes('A') ? this.facility.timeFormat.replace(' A', '') : this.facility.timeFormat;
      this.startTime = this.currentCall.callType === CallsTypes.RealtimeCall ? moment(this.currentCall.start).format(this.facility.timeFormat) : null;

      this.loading = false;
    } catch (e) {
      console.error('mounted() error: ', e);
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    routeToCalender() {
      const { residentId, isVideoCallEnabled } = this.$route.params;
      const params: any = {};

      if (residentId) {
        params.name = 'ResidentView';
        params.params = { id: residentId };
      } else {
        params.name = 'Calendar';
        params.params = {
          isVideoCallEnabled,
          currentWeek: this.currentCall.startISOString,
        };
      }

      this.$router.push(params);
    }
  },
};
